import styled from 'styled-components'
import createComponentFromTagProp from './create-component-from-tag-prop'
import grid from '../mixins/grid'

const GridComponent = createComponentFromTagProp({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['halign', 'valign', 'reverse', 'wrap'],
})

const Grid = styled(GridComponent)`
  display: flex;
  ${grid}
`

export default Grid
